import { render } from "./getterComponent.vue?vue&type=template&id=0f9be82c&scoped=true"
import script from "./getterComponent.vue?vue&type=script&lang=js"
export * from "./getterComponent.vue?vue&type=script&lang=js"

import "./getterComponent.vue?vue&type=style&index=0&id=0f9be82c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9be82c"]])

export default __exports__